// extracted by mini-css-extract-plugin
module.exports = {"holder":"_02712f2b3b--holder--Z_LcJ","content":"_02712f2b3b--content--SubPG","icon-holder":"_02712f2b3b--icon-holder--TADWU","header":"_02712f2b3b--header--OK4q4"};